import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseJwt, getToken, setAutoLogout } from './oauthUtils';

const useAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (!token) return;

    try {
      const parsed = parseJwt(token);
      const expiresAt = parsed?.exp * 1000;
      setAutoLogout(expiresAt, () => {
        navigate('/login');
      });
    } catch (err) {
      console.error("Invalid token format:", err);
      localStorage.clear();
      navigate('/login');
    }
  }, [navigate]);
};

export default useAutoLogout;